import { Component, h, Prop, State, Event, EventEmitter } from '@stencil/core';
import { CmsButtonConfig, Logger } from '../../../global/_types';

@Component({
  tag: 'cms-reset-button',
  styleUrl: 'cms-reset-button.scss',
  shadow: true,
})
export class CmsResetButton {
  static resetEvent: string = 'resetForm';

  @Prop() config: string | CmsButtonConfig;
  @Prop() callback: Function;
  @Prop() debug: boolean = false;

  @State() value: string;

  private logger: Logger;

  /* Config */
  private options: CmsButtonConfig;

  @Event({
    eventName: 'inputFocused',
    composed: true,
    cancelable: true,
    bubbles: true,
  }) inputFocused: EventEmitter;

  @Event({
    eventName: 'resetForm',
    composed: true,
    cancelable: true,
    bubbles: true,
  }) resetForm: EventEmitter;

  componentWillLoad() {
    this.logger = new Logger(this.debug, 'CmsResetButton');

    this.options = typeof (this.config) === 'string' ?
      JSON.parse(this.config) as CmsButtonConfig :
      this.config;
  }

  componentDidLoad() {
    this.logger.trace('CmsResetButton loaded');
  }

  handleClick() {
    this.inputFocused.emit(this);
    this.resetForm.emit({ button: this, form: this.options.form });
    if (this.callback) {
      this.callback();
    }
  }

  render() {
    return (
      <div class="container">
        <div class={`resetButton ${this.options.layout ? '' : 'simple-button'}`}
             style={this.options.width ? {width: this.options.width} : {}}
             tabIndex={0}
             onKeyUp={(ev) => {
               if (ev.key === 'Enter') this.handleClick();
             }}
        >
          <span class={`${this.options.layout ? 'is-button '+this.options.layout : ''}
                  ${this.options.noMargin ? 'no-margin' : ''}
                  ${this.options.icon ? ' icon ' + this.options.icon + (this.options.iconPosition ? ' i-' + this.options.iconPosition : ' i-left') : '' }`}
                id={this.options.name} onClick={this.handleClick.bind(this)}>{this.options.label}</span>
        </div>
      </div>
    );
  }
}
